import React, { useEffect, useRef, useContext } from 'react';
import classNames from 'classnames';
import Link from 'next/link';
import Image from 'next/image';
import styles from './Footer.module.scss';

import { AnimationsActiveContext, GradientContext } from '../../containers/BasePage';
import CookieConsent from '../CookieConsent';

const Footer = ({
    contact = {
        address: {},
    },
    about = [],
    modifiers = [],
}) => {
    const gradient = useContext(GradientContext) || 'PurpleBlue';
    const rootClasses = classNames(
        styles['Root'],
        'grid',
        modifiers.map((m) => styles[m])
    );

    return (
        <div className={rootClasses}>
            <div className={styles['LogoContainer']}>
                <i className={classNames(styles['Gradient'], styles[gradient])} />
                <Link href="/" legacyBehavior={true}>
                    <Image
                        width={228}
                        height={54}
                        src="/img/logo.svg"
                        alt="Stockholm - capital of Scandinavia"
                        className={styles['Logo']}
                    />
                </Link>
            </div>
            {!!contact?.address?.name && (
                <div className={styles['Contact']}>
                    <div className={styles['Title']}>Contact</div>
                    <div className={styles['Address']}>
                        <div className={styles['Name']}>{contact.address.name}</div>
                        <div className={styles['Street']}>{contact.address.street}</div>
                        <div className={styles['Zip']}>
                            {contact.address.zip} {contact.address.city}
                        </div>
                    </div>
                    <div className={styles['ContactLinks']}>
                        {!!contact?.phone && (
                            <div className={styles['Phone']}>
                                <a href={`tel:${contact.phone.replace(/\s+/g, '')}`}>{contact.phone}</a>
                            </div>
                        )}
                        {!!contact?.email && (
                            <div className={styles['Email']}>
                                <a href={`mailto:${contact.email}`}>{contact.email}</a>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div className={styles['About']}>
                <div className={styles['Title']}>About This Website</div>

                {about.map((item, index) => (
                    <div key={index} className={styles['AboutItem']}>
                        {item.href && (
                            <Link href={item.href} legacyBehavior={true}>
                                {item.text}
                            </Link>
                        )}
                    </div>
                ))}

                <CookieConsent buttonClass={styles['AboutItem'] + ' cookie-consent-settings'} />
            </div>
            {!modifiers.includes('NoBg') && <FooterBackground />}
        </div>
    );
};

const FooterBackground = () => {
    const { animationsActive } = useContext(AnimationsActiveContext) || {};
    const gradient = useContext(GradientContext);

    const classes = classNames(styles['Video'], styles[gradient]);

    const videoRef = useRef(null);
    const desktopVideoRef = useRef(null);

    useEffect(() => {
        if (animationsActive) {
            if (videoRef.current) {
                videoRef.current.play();
            }

            if (desktopVideoRef.current) {
                desktopVideoRef.current.play();
            }
        } else {
            if (videoRef.current) {
                videoRef.current.pause();
                videoRef.current.currentTime = 0.3;
            }

            if (desktopVideoRef.current) {
                desktopVideoRef.current.pause();
                desktopVideoRef.current.currentTime = 0.3;
            }
        }
    }, [animationsActive]);

    return (
        <div className={classes}>
            <video
                data-matomo-ignore
                className={styles['PlattanMobile']}
                ref={videoRef}
                preload="auto"
                playsInline
                autoPlay={animationsActive}
                muted
                loop>
                <source src="/video/plattan-gradient-mobile.mp4" type={`video/mp4; codecs="hvc1"`} />
                <source src="/video/plattan-gradient-mobile.webm" type="video/webm" />
                <track kind="subtitles" src="/video/no-audio.vtt" srcLang="en" />
            </video>
            <video
                data-matomo-ignore
                className={styles['PlattanDesktop']}
                ref={desktopVideoRef}
                preload="auto"
                playsInline
                autoPlay={animationsActive}
                muted
                loop>
                <source src="/video/plattan-gradient.mp4" type={`video/mp4; codecs="hvc1"`} />
                <source src="/video/plattan-gradient.webm" type="video/webm" />
                <track kind="subtitles" src="/video/no-audio.vtt" srcLang="en" />
            </video>
        </div>
    );
};
Footer.propTypes = {};

export default Footer;
